import React from 'react';
import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';
import Dropdown from '../../../../../../components/Dropdown';
import DrugSearchInputClean from '../../DrugSearchInputClean.jsx';

export default function RowTop({ styles, rsStyles, f, exp, errors = {}, departmentName, strengthOptions = [], otherStrength, setOtherStrength }) {

  return (
    <>
      <FormRow className={rsStyles.rowSpinnersTop}>
        <Field label="Drug Name" error={errors?.name}>
          <DrugSearchInputClean
            id="receive-stock-drug-search"
            initialValue={f.drugName}
            placeholder="Name of the Drug"
            productType="Drug"
            department={departmentName}
            dropdownOnly={true}
            onInputChange={value => {
              f.setDrugName(value);
            }}
            onSelect={med => {
              if (!med) return;
              if (med.name) f.setDrugName(med.name);
              if (med.barcode) f.setBarcode(med.barcode);
              if (med.activeIngredient) f.setActiveIngredient(med.activeIngredient);
              if (med.strength) f.setStrength(med.strength);
              if (med.nappiCode) f.setNappiCode(med.nappiCode);
              if (med.dosageForm) f.setDosageForm(med.dosageForm);
              if (med.schedule != null) f.setSchedule(String(med.schedule));
              if (med.description) f.setNote(med.description);
              if (med.reorderLevel != null) f.setReorderLevel(med.reorderLevel);
              if (med.costPrice != null) f.setCost(String(med.costPrice));
              if (med.categoryName) {
                f.setCategory(med.categoryName);
              }
            }}
          />
        </Field>
        <Field label="Barcode" error={errors?.barcode}>
          <DrugSearchInputClean
            id="receive-stock-barcode-search"
            initialValue={f.barcode}
            placeholder="Barcode"
            numericOnly
            productType="Drug"
            department={departmentName}
            dropdownOnly={true}
            getDisplayValue={med => (med?.barcode ? String(med.barcode) : '')}
            onInputChange={value => {
              f.setBarcode(value);
            }}
            onSelect={med => {
              if (!med) return;
              if (med.name) f.setDrugName(med.name);
              if (med.barcode) f.setBarcode(med.barcode);
              if (med.activeIngredient) f.setActiveIngredient(med.activeIngredient);
              if (med.strength) f.setStrength(med.strength);
              if (med.nappiCode) f.setNappiCode(med.nappiCode);
              if (med.dosageForm) f.setDosageForm(med.dosageForm);
              if (med.schedule != null) f.setSchedule(String(med.schedule));
              if (med.description) f.setNote(med.description);
              if (med.reorderLevel != null) f.setReorderLevel(med.reorderLevel);
              if (med.costPrice != null) f.setCost(String(med.costPrice));
              if (med.categoryName) f.setCategory(med.categoryName);
            }}
          />
        </Field>
        <Field label="Nappi Code" error={errors?.nappicode}>
          <DrugSearchInputClean
            id="receive-stock-nappi-search"
            initialValue={f.nappiCode}
            placeholder="NappiCode"
            numericOnly
            productType="Drug"
            department={departmentName}
            dropdownOnly={true}
            getDisplayValue={med => (med?.nappiCode ? String(med.nappiCode) : '')}
            onInputChange={value => {
              f.setNappiCode(value);
            }}
            onSelect={med => {
              if (!med) return;
              if (med.name) f.setDrugName(med.name);
              if (med.barcode) f.setBarcode(med.barcode);
              if (med.activeIngredient) f.setActiveIngredient(med.activeIngredient);
              if (med.strength) f.setStrength(med.strength);
              if (med.nappiCode) f.setNappiCode(med.nappiCode);
              if (med.dosageForm) f.setDosageForm(med.dosageForm);
              if (med.schedule != null) f.setSchedule(String(med.schedule));
              if (med.description) f.setNote(med.description);
              if (med.reorderLevel != null) f.setReorderLevel(med.reorderLevel);
              if (med.costPrice != null) f.setCost(String(med.costPrice));
              if (med.categoryName) f.setCategory(med.categoryName);
            }}
          />
        </Field>
      </FormRow>
      <FormRow className={rsStyles.rowSpinnersTop}>
        <Field label="Active ingredient" error={errors?.activeingredient}>
          <input
            className={styles.tallInput}
            type="text"
            placeholder="Active ingredient name"
            value={f.activeIngredient}
            onChange={e => f.setActiveIngredient(e.target.value)}
          />
        </Field>
        <Field label="Strength" error={errors?.strength} className={rsStyles.fieldWithOverlay}>
          {(() => {
            const baseStrengths = Array.isArray(strengthOptions) ? strengthOptions : [];
            const unique = Array.from(new Set(baseStrengths));

            // Always ensure "Other" is present exactly once at the end
            const withoutOther = unique.filter(opt => String(opt) !== 'Other');
            const finalOptions = [...withoutOther, 'Other'];

            const handleStrengthChange = (val) => {
              f.setStrength(val);
              if (val !== 'Other') {
                setOtherStrength('');
              }
            };

            return (
              <>
                <Dropdown
                  name="strength"
                  options={finalOptions}
                  value={f.strength}
                  onChange={handleStrengthChange}
                  placeholder="Select"
                  className={styles.tallInput}
                  maxVisibleOptions={5}
                  alignLeft
                />
                {f.strength === 'Other' && (
                  <div className={rsStyles.inlineBelow}>
                    <input
                      className={`${styles.tallInput} ${styles.fsTextInputUnified}`}
                      type="text"
                      placeholder="Enter strength"
                      value={otherStrength}
                      onChange={e => setOtherStrength(e.target.value)}
                    />
                  </div>
                )}
              </>
            );
          })()}
        </Field>
        <Field label="Pack Size" error={errors?.packsize}>
          <input
            className={styles.tallInput}
            type="text"
            placeholder="100, 30, etc."
            value={f.packSize}
            onChange={e => f.setPackSize(e.target.value)}
          />
        </Field>
      </FormRow>
    </>
  );
}

